import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';

import { Title } from '../title';

import styles from './metabase-dashboard-page.module.css';

import type { MetabaseDashboardPageProps } from './metabase-dashboard-page.type';

export const MetabaseDashboardPage = ({
    title,
    iframeSrc,
    isLoading,
    isError,
    hasCompany,
    loadingMessage,
    errorMessage,
    emptyCompanyMessage,
    onLoaded,
}: MetabaseDashboardPageProps) => {
    const [iframeLoaded, setIframeLoaded] = useState(false);

    useEffect(() => {
        setIframeLoaded(false);
    }, [iframeSrc]);

    const handleIframeLoad = () => {
        setIframeLoaded(true);
        onLoaded?.();
    };

    return (
        <div className={styles.container}>
            <Helmet>
                <title>{`${title} - ${import.meta.env.VITE_APPLICATION_NAME}`}</title>
            </Helmet>

            <Title variant="h5" as="h1">{title}</Title>

            {!hasCompany && <p>{emptyCompanyMessage}</p>}
            {(isLoading || (iframeSrc && !iframeLoaded)) && <p>{loadingMessage}</p>}
            {isError && <p>{errorMessage}</p>}
            {iframeSrc && (
                <iframe
                    className={styles.iframe}
                    src={iframeSrc}
                    title={title}
                    referrerPolicy="no-referrer"
                    onLoad={handleIframeLoad}
                />
            )}
        </div>
    );
};
